import React from "react";

const NotFound = () => {
  return (
    <>
      <div>
        
        <h1>Comming Soon</h1>
      </div>
    </>
  );
};

export default NotFound;
